import { getCodes } from "@/services/code.svc" 
 
 const defaultState = () => ({
  codes: [],
  defaultCodes: {
    brate: 1.35,
    orate: 0.75,
    presb: 0.1,
    genb: 0.1,
    opeb: 0.06,
    offb: 0.04,
    comb: 0.3
  }
 })
 
 export default {
  namespaced: true,
  state: defaultState(),

  actions: {
    async setCodes({ commit }) {
      const codes = await getCodes()
      commit('SET_CODES', codes)
    }
  },

  getters: {
    codes: (state) => state.codes,
    getCodeByType: (state) => (type) => {
      const code = state.codes.find(c => c.Type === type)?.Code || 0
      return isNaN(parseInt(code)) ? state.defaultCodes[type] : code
    }
  },

  mutations: {
    SET_CODES(state, payload) {
      state.codes = payload
    }
  }
 }